<template>
  <div class="appoint-search">
    <div class="content">
      <van-search
        class="search-bar"
        v-model="searchValue"
        shape="round"
        :placeholder="placeholder"
        @search="onSearch"
        @clear="onClear"
        @input="onInput"
      />
    </div>
    <div style="height: 54px;"></div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      searchValue: ''
    }
  },
  watch: {},
  computed: {},
  methods: {
    onInput(val) {
      this.searchValue = val
      this.$emit('input', val)
    },
    onSearch() {
      this.$emit('search', this.searchValue)
    },
    onClear() {
      this.searchValue = ''
      this.$emit('clear')
    }
  },
  created() {},
  mounted() {}
}
</script>
<style lang="scss" scoped>
.appoint-search {
  background: #ffffff;
  .content {
    position: fixed;
    width: 100%;
    z-index: 1;
  }
  .search-bar {
    width: 100%;
    ::v-deep .van-search__content {
      background-color: #f4f4f4;
    }
  }
}
</style>
